import './bootstrap.js';
import SigmaWaveSurfer from 'wavesurfer.js'
import { SigmaChat } from './sigma-chat-v2.js';

window.SigmaChat = SigmaChat
window.SigmaWaveSurfer = SigmaWaveSurfer

